const PAGE_LABELS: Record<string, string> = {
  "/dashboard": "Painel",
  "/budgets": "Lista de orçamentos",
  "/budget": "Orçamento",
  "/bim": "BIM / IFC",
  "/works": "Obras",
  "/documents": "Documentos",
  "/measurement-autos": "Autos de medição",
  "/cost-database": "Base de preços",
  "/contacts": "Contactos",
  "/settings": "Definições",
  "/templates": "Modelos",
  "/help": "Ajuda",
};

const ASSISTANT_HIDDEN_PREFIXES = ["/", "/auth", "/invite", "/legal"];

export function shouldShowAssistant(pathname: string): boolean {
  if (!pathname || pathname === "/") {
    return false;
  }

  return !ASSISTANT_HIDDEN_PREFIXES.some((prefix) =>
    prefix === "/" ? false : pathname.startsWith(prefix),
  );
}

export function getAssistantPageContext(pathname: string): string {
  for (const [prefix, label] of Object.entries(PAGE_LABELS)) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      return label;
    }
  }

  return "Área interna";
}
